function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container, focusOptions) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus(focusOptions);
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

(() => {
  let isScheduled = false;
  let headerResizeObserver = null;

  const productStickySelector = [
    ".product-detail-section .product__media-gallery",
    ".product-detail-section .product__info-container--sticky",
  ].join(", ");

  const hasProductStickyElements = () =>
    Boolean(document.querySelector(productStickySelector));

  const measureHeaderOffset = () => {
    isScheduled = false;

    const header = document.getElementById("shopify-section-header");
    if (!header) return;

    const headerRect = header.getBoundingClientRect();
    const headerHeight = Math.ceil(headerRect.height || header.offsetHeight || 0);

    if (headerHeight > 0) {
      document.documentElement.style.setProperty(
        "--header-height",
        `${headerHeight}px`
      );
    }

    if (!hasProductStickyElements()) return;

    const visibleHeaderBottom = Math.max(0, Math.ceil(headerRect.bottom));
    const stickyBase = visibleHeaderBottom || headerHeight;

    document.documentElement.style.setProperty(
      "--product-detail-sticky-top",
      `calc(${stickyBase}px + var(--product-detail-sticky-gap, 1.6rem))`
    );
  };

  const scheduleHeaderOffsetMeasure = () => {
    if (isScheduled) return;
    isScheduled = true;

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(measureHeaderOffset);
    } else {
      window.setTimeout(measureHeaderOffset, 0);
    }
  };

  const bindHeaderOffsetMeasure = () => {
    measureHeaderOffset();

    window.addEventListener("resize", scheduleHeaderOffsetMeasure);
    window.addEventListener("load", scheduleHeaderOffsetMeasure);
    document.addEventListener("shopify:section:load", scheduleHeaderOffsetMeasure);

    if (hasProductStickyElements()) {
      window.addEventListener("scroll", scheduleHeaderOffsetMeasure, {
        passive: true,
      });
    }

    if ("ResizeObserver" in window) {
      const header = document.getElementById("shopify-section-header");
      if (header) {
        headerResizeObserver = new ResizeObserver(scheduleHeaderOffsetMeasure);
        headerResizeObserver.observe(header);
      }
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindHeaderOffsetMeasure, {
      once: true,
    });
  } else {
    bindHeaderOffsetMeasure();
  }
})();

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function formatProductAddButtonMoney(cents, moneyFormat) {
  if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
    return window.Shopify.formatMoney(cents, moneyFormat);
  }

  const amount = Number(cents || 0) / 100;
  const currency =
    window.Shopify && Shopify.currency && Shopify.currency.active
      ? Shopify.currency.active
      : "USD";

  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
    }).format(amount);
  } catch (error) {
    return "$" + amount.toFixed(2);
  }
}

function getProductAddButtonSectionId(productForm) {
  if (!productForm) return "";

  const formId =
    typeof productForm.getAttribute === "function"
      ? productForm.getAttribute("id")
      : productForm.id;

  return typeof formId === "string" ? formId.replace(/^product-form-/, "") : "";
}

function getProductAddButtonQuantity(productForm, sectionId) {
  const quantityInput =
    (sectionId && document.getElementById(`Quantity-${sectionId}`)) ||
    productForm.querySelector('input[name="quantity"]');
  const quantity = Number.parseInt(quantityInput && quantityInput.value, 10);

  return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
}

function getProductVariantFromForm(productForm, addButton, sectionId) {
  const variantIdInput = productForm.querySelector('input[name="id"]');
  const variantId = Number(variantIdInput && variantIdInput.value);
  const variantPicker = Array.from(
    document.querySelectorAll("variant-radios, variant-selects")
  ).find((picker) => picker.dataset.section === sectionId);

  if (variantPicker) {
    const variants =
      typeof variantPicker.getVariantData === "function"
        ? variantPicker.getVariantData()
        : JSON.parse(
            variantPicker.querySelector('[type="application/json"]').textContent
          );
    const selectedVariant = variants.find((variant) => variant.id === variantId);

    if (selectedVariant) return selectedVariant;
  }

  if (!addButton.dataset.selectedVariantPrice) return null;

  return {
    id: variantId,
    available: !addButton.hasAttribute("disabled"),
    price: Number(addButton.dataset.selectedVariantPrice),
    compare_at_price: Number(addButton.dataset.selectedVariantCompareAtPrice || 0),
    selling_plan_allocations: JSON.parse(addButton.dataset.sellingPlanAllocations || '[]'),
  };
}

function updateProductAddButtonLabel(productForm, variant = null) {
  if (!productForm) return;

  const addButton = productForm.querySelector(
    '[name="add"][data-add-to-cart-price-label]'
  );
  const addButtonText = addButton && addButton.querySelector("span");

  if (!addButton || !addButtonText) return;

  const sectionId = getProductAddButtonSectionId(productForm);
  const selectedVariant =
    variant || getProductVariantFromForm(productForm, addButton, sectionId);

  const sellingPlanId = productForm.querySelector('[name="selling_plan"]')?.value;
  window.DubiaLowestPrice?.update(productForm, selectedVariant, sellingPlanId);
  if (!selectedVariant || !selectedVariant.available) return;

  const quantity = getProductAddButtonQuantity(productForm, sectionId);
  const allocation = selectedVariant.selling_plan_allocations?.find(
    (plan) => String(plan.selling_plan_id) === sellingPlanId
  );
  const unitPrice = Number(allocation?.price ?? selectedVariant.price ?? 0);
  const price = formatProductAddButtonMoney(
    unitPrice * quantity,
    addButton.dataset.moneyFormat
  );

  // Keep the headline total and comparison consistent with the selected purchase plan.
  const compareAtPrice = Number(allocation
    ? allocation.compare_at_price || selectedVariant.price
    : selectedVariant.compare_at_price || 0);
  [`price-${sectionId}`, `price-quantity-${sectionId}`].forEach((id) => {
    const root = document.getElementById(id);
    if (!root) return;
    root.querySelectorAll('[data-product-unit-price]').forEach((element) => {
      const role = element.dataset.productPriceRole;
      const amount = role === 'current' ? unitPrice
        : role === 'compare' ? compareAtPrice : Number(element.dataset.productUnitPrice);
      element.textContent = formatProductAddButtonMoney(amount * quantity, addButton.dataset.moneyFormat);
    });
    root.querySelector('.price')?.classList.toggle('price--on-sale', compareAtPrice > unitPrice);
    const discount = root.querySelector('[data-product-discount]');
    if (discount) {
      discount.hidden = compareAtPrice <= unitPrice;
      discount.textContent = compareAtPrice > unitPrice
        ? `-${Math.round((compareAtPrice - unitPrice) * 100 / compareAtPrice)}%` : '';
    }
    const compareLabel = root.querySelector('[data-product-compare-label]');
    if (compareLabel) compareLabel.textContent = allocation ? 'One-time price:' : 'Original price:';
  });

  addButton.dataset.selectedVariantPrice = selectedVariant.price;
  addButton.dataset.selectedVariantCompareAtPrice = selectedVariant.compare_at_price || 0;
  addButtonText.textContent = `Add to cart · ${price}`;
}

window.updateProductAddButtonLabel = updateProductAddButtonLabel;

document.addEventListener("input", (event) => {
  if (!event.target.matches('input[name="quantity"][id^="Quantity-"]')) return;

  const productForm = document.getElementById(event.target.getAttribute("form"));
  updateProductAddButtonLabel(productForm);
});

document.addEventListener("change", (event) => {
  if (!event.target.matches('input[name="quantity"][id^="Quantity-"]')) return;

  const productForm = document.getElementById(event.target.getAttribute("form"));
  updateProductAddButtonLabel(productForm);
});

document.addEventListener("change", (event) => {
  if (!event.target.matches('form[id^="product-form-"] input:is([name="id"], [name="selling_plan"])')) return;

  updateProductAddButtonLabel(event.target.closest("form"));
});

function updateProductAddButtonLabels() {
  document
    .querySelectorAll('form[id^="product-form-"]')
    .forEach((productForm) => updateProductAddButtonLabel(productForm));
}

document.addEventListener("DOMContentLoaded", updateProductAddButtonLabels);

// Recharge updates its hidden input without dispatching a native change event.
window.RechargeSubscriptionWidgetReady = ({ events }) => {
  events.onSellingPlanChange(updateProductAddButtonLabels);
  updateProductAddButtonLabels();
};

(function () {
  const APP_CLASS = "in-dubia-app";
  const APP_NAV_STACK_KEY = "dubiaAppNavigationStack";
  const APP_LOGGED_OUT_KEY = "dubiaAppLoggedOut";
  const MAX_APP_NAV_STACK = 50;
  const APP_LOGOUT_PATH = "/account/logout";
  const APP_AUTH_PATHS = [
    "/account/login",
    "/account/register",
    "/tools/recurring/get-subscription-access",
    "/tools/recurring/login",
  ];

  function isDubiaApp() {
    try {
      return /\bDubiaRoachesApp\b/.test(navigator.userAgent);
    } catch (error) {
      return false;
    }
  }

  function applyAppClass() {
    if (isDubiaApp()) {
      document.documentElement.classList.add(APP_CLASS);
    }
  }

  function getParsedUrl(url) {
    try {
      return new URL(url || window.location.href, window.location.href);
    } catch (error) {
      return null;
    }
  }

  function getSameOriginUrl(url) {
    const parsedUrl = getParsedUrl(url);

    if (!parsedUrl || parsedUrl.origin !== window.location.origin) return null;

    return parsedUrl.href;
  }

  function getAppAuthUrl(link) {
    if (!link || link.getAttribute("data-app-auth-handoff") === "false") {
      return null;
    }

    const parsedUrl = getParsedUrl(link.getAttribute("href"));

    if (!parsedUrl) return null;
    if (
      parsedUrl.origin !== window.location.origin &&
      !/\.shopify\.com$/i.test(parsedUrl.hostname)
    ) {
      return null;
    }

    return isAppAuthPath(parsedUrl) ? parsedUrl.href : null;
  }

  function isAppAuthPath(parsedUrl) {
    if (!parsedUrl) return false;

    return APP_AUTH_PATHS.some((path) => {
      return parsedUrl.pathname === path || parsedUrl.pathname.endsWith(path);
    });
  }

  function isAppAccountLoginUrl(parsedUrl) {
    if (!parsedUrl || parsedUrl.origin !== window.location.origin) return false;

    return ["/account/login", "/account/register", APP_LOGOUT_PATH].some((path) => {
      return parsedUrl.pathname === path || parsedUrl.pathname.endsWith(path);
    });
  }

  function isProtectedAccountUrl(parsedUrl) {
    if (!parsedUrl || parsedUrl.origin !== window.location.origin) return false;
    if (!parsedUrl.pathname.startsWith("/account")) return false;

    return !isAppAccountLoginUrl(parsedUrl);
  }

  function getAppProtectedAccountUrl(link) {
    if (!link || link.getAttribute("data-app-account-redirect") === "false") {
      return null;
    }

    const parsedUrl = getParsedUrl(link.getAttribute("href"));

    return isProtectedAccountUrl(parsedUrl) ? parsedUrl.href : null;
  }

  function getAppFooterAccountLink(target) {
    const element =
      target && target.closest
        ? target
        : target && target.parentElement;
    const link = element ? element.closest("a[data-app-account-link]") : null;

    if (!link || link.getAttribute("data-app-account-link") === "false") {
      return null;
    }

    return link;
  }

  function getShopifyRouteRoot() {
    const routesRoot =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const parsedRoot = getParsedUrl(routesRoot || "/");
    let rootPath = parsedRoot ? parsedRoot.pathname : "/";

    if (!rootPath) rootPath = "/";
    if (rootPath.charAt(0) !== "/") rootPath = "/" + rootPath;
    if (rootPath.charAt(rootPath.length - 1) !== "/") rootPath += "/";

    return rootPath;
  }

  function getAccountLoginUrl(link) {
    const explicitHref = link && link.getAttribute("data-app-account-login-url");
    const explicitUrl = explicitHref ? getSameOriginUrl(explicitHref) : null;

    if (explicitUrl) return explicitUrl;

    return new URL(getShopifyRouteRoot() + "account/login", window.location.origin).href;
  }

  function getAppLogoutUrl(link) {
    if (!link || link.getAttribute("data-app-logout-replace") === "false") {
      return null;
    }

    const parsedUrl = getParsedUrl(link.getAttribute("href"));

    if (!parsedUrl || parsedUrl.origin !== window.location.origin) return null;

    return parsedUrl.pathname === APP_LOGOUT_PATH ||
      parsedUrl.pathname.endsWith(APP_LOGOUT_PATH)
      ? parsedUrl.href
      : null;
  }

  function clearAppNavStack() {
    try {
      window.sessionStorage.removeItem(APP_NAV_STACK_KEY);
    } catch (error) {}
  }

  function markAppLoggedOut() {
    try {
      window.sessionStorage.setItem(APP_LOGGED_OUT_KEY, "true");
    } catch (error) {}
  }

  function clearAppLoggedOut() {
    try {
      window.sessionStorage.removeItem(APP_LOGGED_OUT_KEY);
    } catch (error) {}
  }

  function hasAppLoggedOut() {
    try {
      return window.sessionStorage.getItem(APP_LOGGED_OUT_KEY) === "true";
    } catch (error) {
      return false;
    }
  }

  function isProtectedAccountPath() {
    const parsedUrl = getParsedUrl(window.location.href);

    return isProtectedAccountUrl(parsedUrl);
  }

  function postAppBridgeMessage(message) {
    let didPost = false;

    try {
      if (
        window.DubiaAppNavigation &&
        typeof window.DubiaAppNavigation.openExternal === "function"
      ) {
        window.DubiaAppNavigation.openExternal(message.url);
        didPost = true;
      }
    } catch (error) {}

    try {
      if (
        window.ReactNativeWebView &&
        typeof window.ReactNativeWebView.postMessage === "function"
      ) {
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
        didPost = true;
      }
    } catch (error) {}

    [
      "dubiaAppOpenExternal",
      "dubiaAppOpenUrl",
      "dubiaAppAuth",
    ].forEach((handlerName) => {
      try {
        const handler =
          window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers[handlerName];

        if (handler && typeof handler.postMessage === "function") {
          handler.postMessage(message);
          didPost = true;
        }
      } catch (error) {}
    });

    try {
      if (window.Android && typeof window.Android.openExternal === "function") {
        window.Android.openExternal(message.url);
        didPost = true;
      } else if (window.Android && typeof window.Android.openUrl === "function") {
        window.Android.openUrl(message.url);
        didPost = true;
      } else if (
        window.Android &&
        typeof window.Android.postMessage === "function"
      ) {
        window.Android.postMessage(JSON.stringify(message));
        didPost = true;
      }
    } catch (error) {}

    return didPost;
  }

  function handOffAppAuth(url) {
    const message = {
      type: "openExternal",
      reason: "account_auth",
      url: url,
    };

    if (!postAppBridgeMessage(message)) return false;

    let shouldFallback = true;
    let fallbackTimer = null;

    const cleanup = function () {
      shouldFallback = false;
      if (fallbackTimer) window.clearTimeout(fallbackTimer);
      window.removeEventListener("pagehide", cleanup);
      window.removeEventListener("blur", cleanup);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };

    const handleVisibilityChange = function () {
      if (document.visibilityState === "hidden") cleanup();
    };

    window.addEventListener("pagehide", cleanup, { once: true });
    window.addEventListener("blur", cleanup, { once: true });
    document.addEventListener("visibilitychange", handleVisibilityChange);

    fallbackTimer = window.setTimeout(function () {
      if (!shouldFallback) return;
      cleanup();
      window.location.href = url;
    }, 900);

    return true;
  }

  function normalizeStackEntry(entry) {
    const url = typeof entry === "string" ? entry : entry && entry.url;
    const sameOriginUrl = getSameOriginUrl(url);

    if (!sameOriginUrl) return null;

    return {
      url: sameOriginUrl,
      sameDocument: !!(entry && entry.sameDocument),
    };
  }

  function readAppNavStack() {
    try {
      const storedStack = window.sessionStorage.getItem(APP_NAV_STACK_KEY);
      const parsedStack = storedStack ? JSON.parse(storedStack) : [];

      if (!Array.isArray(parsedStack)) return [];

      return parsedStack
        .map(normalizeStackEntry)
        .filter(Boolean)
        .slice(-MAX_APP_NAV_STACK);
    } catch (error) {
      return [];
    }
  }

  function writeAppNavStack(stack) {
    try {
      window.sessionStorage.setItem(
        APP_NAV_STACK_KEY,
        JSON.stringify(stack.slice(-MAX_APP_NAV_STACK))
      );
    } catch (error) {}
  }

  function getCurrentStackEntry(sameDocument = false) {
    const currentUrl = getSameOriginUrl(window.location.href);

    if (!currentUrl) return null;

    return {
      url: currentUrl,
      sameDocument: sameDocument,
    };
  }

  function findStackUrlIndex(stack, url) {
    for (let index = stack.length - 1; index >= 0; index--) {
      if (stack[index].url === url) return index;
    }

    return -1;
  }

  function getNavigationType() {
    try {
      const navigation = window.performance.getEntriesByType("navigation")[0];
      if (navigation && navigation.type) return navigation.type;
    } catch (error) {}

    try {
      if (window.performance.navigation.type === 2) return "back_forward";
      if (window.performance.navigation.type === 1) return "reload";
    } catch (error) {}

    return "";
  }

  function recordCurrentDocument(preserveSameDocument = false) {
    if (!isDubiaApp()) return;

    const currentEntry = getCurrentStackEntry(false);

    if (!currentEntry) return;

    let stack = readAppNavStack();
    const existingEntry = stack[stack.length - 1];

    if (existingEntry && existingEntry.url === currentEntry.url) {
      existingEntry.sameDocument = preserveSameDocument
        ? existingEntry.sameDocument
        : false;
    } else {
      stack.push(currentEntry);
    }

    writeAppNavStack(stack);
  }

  function resetStackToCurrentDocument() {
    const currentEntry = getCurrentStackEntry(false);

    if (!currentEntry) return;

    writeAppNavStack([currentEntry]);
  }

  function hasSameOriginReferrer() {
    if (!document.referrer) return false;

    const referrerUrl = getParsedUrl(document.referrer);

    return !!referrerUrl && referrerUrl.origin === window.location.origin;
  }

  function shouldResetStackForInitialEntry() {
    const navigationType = getNavigationType();

    if (navigationType === "back_forward" || navigationType === "reload") {
      return false;
    }

    return !hasSameOriginReferrer();
  }

  function pushCurrentHistoryEntry() {
    if (!isDubiaApp()) return;

    const currentEntry = getCurrentStackEntry(true);

    if (!currentEntry) return;

    const stack = readAppNavStack();
    stack.push(currentEntry);
    writeAppNavStack(stack);
  }

  function replaceCurrentHistoryEntry() {
    if (!isDubiaApp()) return;

    const currentEntry = getCurrentStackEntry(false);

    if (!currentEntry) return;

    const stack = readAppNavStack();
    const existingEntry = stack[stack.length - 1];

    currentEntry.sameDocument = existingEntry
      ? !!existingEntry.sameDocument
      : false;

    if (stack.length) {
      stack[stack.length - 1] = currentEntry;
    } else {
      stack.push(currentEntry);
    }

    writeAppNavStack(stack);
  }

  function syncStackToCurrentUrl() {
    if (!isDubiaApp()) return;

    const currentUrl = getSameOriginUrl(window.location.href);

    if (!currentUrl) return;

    let stack = readAppNavStack();
    const currentIndex = findStackUrlIndex(stack, currentUrl);

    if (currentIndex > -1) {
      stack = stack.slice(0, currentIndex + 1);
    } else {
      stack.push({
        url: currentUrl,
        sameDocument: false,
      });
    }

    writeAppNavStack(stack);
  }

  function wrapHistory() {
    if (!isDubiaApp()) return;
    if (window.__dubiaAppHistoryWrapped) return;
    if (!window.history || !window.history.pushState) return;
    if (!window.history.replaceState) return;

    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function () {
      const result = originalPushState.apply(this, arguments);
      pushCurrentHistoryEntry();
      return result;
    };

    window.history.replaceState = function () {
      const result = originalReplaceState.apply(this, arguments);
      replaceCurrentHistoryEntry();
      return result;
    };

    window.__dubiaAppHistoryWrapped = true;
  }

  function closeOpenMenuDrawer() {
    const openDetails = Array.from(
      document.querySelectorAll(
        "#Details-menu-drawer-container[open], header-drawer details[open], menu-drawer details[open]"
      )
    );

    if (!openDetails.length) return false;

    const drawers = Array.from(
      new Set(
        openDetails
          .map((details) => details.closest("header-drawer, menu-drawer"))
          .filter(Boolean)
      )
    );

    drawers.forEach((drawer) => {
      const drawerDetails =
        drawer.mainDetailsToggle || drawer.querySelector("details[open]");
      const summary = drawerDetails
        ? drawerDetails.querySelector("summary")
        : null;

      if (
        drawerDetails &&
        drawerDetails.hasAttribute("open") &&
        typeof drawer.closeMenuDrawer === "function"
      ) {
        drawer.closeMenuDrawer({}, summary);
        return;
      }

      drawer.querySelectorAll("details[open]").forEach((details) => {
        const detailsSummary = details.querySelector("summary");

        details.classList.remove("menu-opening");
        details.removeAttribute("open");
        if (detailsSummary) detailsSummary.setAttribute("aria-expanded", false);
      });
    });

    openDetails
      .filter((details) => !details.closest("header-drawer, menu-drawer"))
      .forEach((details) => {
        const detailsSummary = details.querySelector("summary");

        details.classList.remove("menu-opening");
        details.removeAttribute("open");
        if (detailsSummary) detailsSummary.setAttribute("aria-expanded", false);
      });

    document.body.classList.remove(
      "overflow-hidden-mobile",
      "overflow-hidden-tablet",
      "overflow-hidden-desktop"
    );
    removeTrapFocus();

    return true;
  }

  function closeDetailsElement(details) {
    const summary = details.querySelector("summary");

    details.removeAttribute("open");
    if (summary) summary.setAttribute("aria-expanded", false);
    document.body.classList.remove("overflow-hidden");
    removeTrapFocus(summary);
  }

  function closeOpenSearch() {
    let search = document.querySelector('dubia-search[show="true"]');

    if (!search) {
      const openHolder = document.querySelector(
        "dubia-search .dr-search-holder.dr-is-open"
      );
      search = openHolder ? openHolder.closest("dubia-search") : null;
    }

    if (!search) return false;

    if (typeof search.close === "function") {
      search.close();
    } else {
      search.setAttribute("show", "false");
    }

    return true;
  }

  function closeOpenDetailsModal() {
    const details = document.querySelector(
      "details-modal details[open], details[open] > .search-modal"
    );

    if (!details) return false;

    const detailsElement =
      details.tagName === "DETAILS" ? details : details.closest("details");
    const detailsModal = detailsElement
      ? detailsElement.closest("details-modal")
      : null;

    if (detailsModal && typeof detailsModal.close === "function") {
      detailsModal.close();
    } else if (detailsElement) {
      closeDetailsElement(detailsElement);
    }

    return true;
  }

  function closeOpenModalDialog() {
    const modal = document.querySelector("modal-dialog[open]");

    if (!modal) return false;

    if (typeof modal.hide === "function") {
      modal.hide();
    } else {
      modal.removeAttribute("open");
      document.body.classList.remove("overflow-hidden");
      removeTrapFocus();
    }

    return true;
  }

  function closeCartNotification() {
    const notification = document.querySelector(
      "#cart-notification.active, .cart-notification.active"
    );

    if (!notification) return false;

    const cartNotification =
      notification.closest("cart-notification") ||
      document.querySelector("cart-notification");

    if (cartNotification && typeof cartNotification.close === "function") {
      cartNotification.close();
    } else {
      notification.classList.remove("active");
      removeTrapFocus();
    }

    return true;
  }

  function dispatchHashChange(oldUrl) {
    try {
      window.dispatchEvent(
        new HashChangeEvent("hashchange", {
          oldURL: oldUrl,
          newURL: window.location.href,
        })
      );
      return;
    } catch (error) {}

    try {
      window.dispatchEvent(new Event("hashchange"));
      return;
    } catch (error) {}

    try {
      const event = document.createEvent("Event");
      event.initEvent("hashchange", false, false);
      window.dispatchEvent(event);
    } catch (error) {}
  }

  function closeRecoverHash() {
    if (window.location.hash !== "#recover") return false;

    const oldUrl = window.location.href;
    const nextUrl = window.location.pathname + window.location.search;

    try {
      window.history.replaceState(window.history.state, "", nextUrl);
      dispatchHashChange(oldUrl);
    } catch (error) {
      window.location.replace(nextUrl);
    }

    return true;
  }

  function closeTransientUi() {
    return (
      closeOpenMenuDrawer() ||
      closeOpenSearch() ||
      closeOpenDetailsModal() ||
      closeOpenModalDialog() ||
      closeCartNotification() ||
      closeRecoverHash()
    );
  }

  function tryNativeBridgeBack() {
    let canUseNativeBridge = false;

    try {
      canUseNativeBridge =
        window.DubiaAppBridgeCanGoBack === true ||
        (window.DubiaAppNavigation &&
          typeof window.DubiaAppNavigation.canGoBack === "function" &&
          window.DubiaAppNavigation.canGoBack());
    } catch (error) {
      canUseNativeBridge = false;
    }

    try {
      if (
        !canUseNativeBridge &&
        window.Android &&
        typeof window.Android.canGoBack === "function"
      ) {
        canUseNativeBridge = window.Android.canGoBack();
      }
    } catch (error) {}

    if (!canUseNativeBridge) return false;

    try {
      if (
        window.ReactNativeWebView &&
        typeof window.ReactNativeWebView.postMessage === "function"
      ) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "goBack" })
        );
        return true;
      }
    } catch (error) {}

    try {
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.dubiaAppBack &&
        typeof window.webkit.messageHandlers.dubiaAppBack.postMessage ===
          "function"
      ) {
        window.webkit.messageHandlers.dubiaAppBack.postMessage({
          type: "goBack",
        });
        return true;
      }
    } catch (error) {}

    try {
      if (window.Android && typeof window.Android.goBack === "function") {
        window.Android.goBack();
        return true;
      }
    } catch (error) {}

    return false;
  }

  function isSameDocumentBack(currentEntry, previousEntry) {
    const currentUrl = getParsedUrl(currentEntry && currentEntry.url);
    const previousUrl = getParsedUrl(previousEntry && previousEntry.url);

    if (!currentEntry || !currentEntry.sameDocument) return false;
    if (!currentUrl || !previousUrl) return false;
    if (currentUrl.origin !== previousUrl.origin) return false;

    return currentUrl.pathname === previousUrl.pathname;
  }

  function getFallbackUrl(link) {
    const linkHref = link && link.getAttribute("href");
    const linkUrl = getSameOriginUrl(linkHref);

    if (linkUrl) return linkUrl;

    const routesRoot =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const rootUrl = getSameOriginUrl(routesRoot || "/");

    return rootUrl || "/";
  }

  function trimStackToPrevious(stack) {
    if (stack.length > 1) {
      writeAppNavStack(stack.slice(0, stack.length - 1));
    }
  }

  function getPreviousStackEntry() {
    syncStackToCurrentUrl();

    const stack = readAppNavStack();
    const currentEntry = stack[stack.length - 1];
    const previousEntry = stack[stack.length - 2];

    return {
      stack: stack,
      currentEntry: currentEntry,
      previousEntry: previousEntry,
      previousUrl: getParsedUrl(previousEntry && previousEntry.url),
    };
  }

  function navigateToFallback(link) {
    const fallbackUrl = getFallbackUrl(link);

    writeAppNavStack([
      {
        url: fallbackUrl,
        sameDocument: false,
      },
    ]);
    window.location.replace(fallbackUrl);
  }

  function navigateWithAppStack() {
    const navigation = getPreviousStackEntry();

    if (
      navigation.previousEntry &&
      navigation.previousUrl &&
      navigation.previousUrl.origin === window.location.origin
    ) {
      if (
        isSameDocumentBack(navigation.currentEntry, navigation.previousEntry)
      ) {
        trimStackToPrevious(navigation.stack);
        window.history.back();
      } else {
        trimStackToPrevious(navigation.stack);
        window.location.replace(navigation.previousUrl.href);
      }
      return true;
    }

    return false;
  }

  function onAppBackClick(event) {
    const target =
      event.target && event.target.closest
        ? event.target
        : event.target && event.target.parentElement;
    const backButton = target
      ? target.closest("[data-app-back-button]")
      : null;

    if (!backButton || !isDubiaApp()) return;

    event.preventDefault();

    if (closeTransientUi()) return;
    if (navigateWithAppStack()) return;

    navigateToFallback(backButton);
  }

  function onAppAuthClick(event) {
    if (!isDubiaApp() || event.defaultPrevented) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const target =
      event.target && event.target.closest
        ? event.target
        : event.target && event.target.parentElement;
    const link = target ? target.closest("a[href]") : null;
    const authUrl = getAppAuthUrl(link);

    if (!authUrl) return;
    if (hasAppLoggedOut() && isAppAuthPath(getParsedUrl(authUrl))) return;

    event.preventDefault();

    if (!handOffAppAuth(authUrl)) {
      window.location.href = authUrl;
    }
  }

  function onAppLogoutClick(event) {
    if (!isDubiaApp() || event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const target =
      event.target && event.target.closest
        ? event.target
        : event.target && event.target.parentElement;
    const link = target ? target.closest("a[href]") : null;
    const logoutUrl = getAppLogoutUrl(link);

    if (!logoutUrl) return;

    clearAppNavStack();
    markAppLoggedOut();
  }

  function onAppProtectedAccountClick(event) {
    if (!isDubiaApp() || event.defaultPrevented || !hasAppLoggedOut()) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const target =
      event.target && event.target.closest
        ? event.target
        : event.target && event.target.parentElement;
    const link = target ? target.closest("a[href]") : null;
    const accountUrl = getAppProtectedAccountUrl(link);

    if (!accountUrl) return;

    event.preventDefault();
    window.location.replace(getAccountLoginUrl(link));
  }

  function onAppStaleFooterAccountClick(event) {
    if (!isDubiaApp() || event.defaultPrevented || !hasAppLoggedOut()) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const accountLink = getAppFooterAccountLink(event.target);
    const accountUrl = getAppProtectedAccountUrl(accountLink);

    if (!accountUrl) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.replace(getAccountLoginUrl(accountLink));
  }

  applyAppClass();
  wrapHistory();
  if (getNavigationType() === "back_forward") {
    syncStackToCurrentUrl();
  } else if (shouldResetStackForInitialEntry()) {
    resetStackToCurrentDocument();
  } else {
    recordCurrentDocument();
  }

  document.addEventListener("click", onAppBackClick);
  document.addEventListener("click", onAppStaleFooterAccountClick, true);
  document.addEventListener("click", onAppLogoutClick);
  document.addEventListener("click", onAppProtectedAccountClick);
  document.addEventListener("click", onAppAuthClick);
  window.addEventListener("pageshow", (event) => {
    applyAppClass();
    if (event.persisted) {
      syncStackToCurrentUrl();
      if (isDubiaApp() && isProtectedAccountPath()) {
        if (hasAppLoggedOut()) {
          window.location.replace(getAccountLoginUrl(null));
        } else {
          window.location.reload();
        }
        return;
      }
    }
    if (!event.persisted && isDubiaApp() && isProtectedAccountPath()) {
      clearAppLoggedOut();
    }
  });
  window.addEventListener("popstate", () => {
    setTimeout(syncStackToCurrentUrl, 0);
  });
})();

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
    this.bindMobileFacetsDragEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    this.resetMobileFacetsDrag();
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      const wasFooterTriggered = this.mainDetailsToggle.classList.contains(
        "menu-drawer-container--footer-triggered"
      );

      this.resetMobileFacetsDrag();
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(wasFooterTriggered ? false : elementToFocus);
      if (wasFooterTriggered && elementToFocus) {
        elementToFocus.classList.remove("focused");
        elementToFocus.blur();
      }
      this.closeAnimation(this.mainDetailsToggle);
      if (wasFooterTriggered) {
        window.setTimeout(() => {
          this.mainDetailsToggle.classList.remove(
            "menu-drawer-container--footer-triggered"
          );
        }, 450);
      }
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  bindMobileFacetsDragEvents() {
    if (!this.classList.contains("mobile-facets__wrapper")) return;

    this.mobileFacetsInner = this.querySelector(".mobile-facets__inner");
    if (!this.mobileFacetsInner) return;

    this.mobileFacetsTouch = null;
    this.mobileFacetsInner.addEventListener(
      "touchstart",
      this.onMobileFacetsTouchStart.bind(this),
      { passive: true }
    );
    this.mobileFacetsInner.addEventListener(
      "touchmove",
      this.onMobileFacetsTouchMove.bind(this),
      { passive: false }
    );
    this.mobileFacetsInner.addEventListener(
      "touchend",
      this.onMobileFacetsTouchEnd.bind(this),
      { passive: true }
    );
    this.mobileFacetsInner.addEventListener(
      "touchcancel",
      this.onMobileFacetsTouchEnd.bind(this),
      { passive: true }
    );
  }

  onMobileFacetsTouchStart(event) {
    const touch = event.touches && event.touches[0];
    const drawerRect = this.mobileFacetsInner
      ? this.mobileFacetsInner.getBoundingClientRect()
      : null;
    const scroller = event.target.closest(
      ".mobile-facets__main, .mobile-facets__submenu"
    );

    if (!touch || !this.isMobileFacetsDrawerOpen()) return;

    this.mobileFacetsTouch = {
      startX: touch.clientX,
      startY: touch.clientY,
      lastX: touch.clientX,
      lastY: touch.clientY,
      startTime: Date.now(),
      mode: null,
      scroller,
      startScrollTop: scroller ? scroller.scrollTop : 0,
      startedOnDragArea:
        Boolean(event.target.closest(".mobile-facets__header")) ||
        (drawerRect ? touch.clientY - drawerRect.top <= 72 : false),
      startedOnInteractive: Boolean(
        event.target.closest("a, button, input, select, textarea, label")
      ),
    };
  }

  onMobileFacetsTouchMove(event) {
    const touch = event.touches && event.touches[0];
    let dx;
    let dy;

    if (!touch || !this.mobileFacetsTouch || !this.mobileFacetsInner) return;

    dx = touch.clientX - this.mobileFacetsTouch.startX;
    dy = touch.clientY - this.mobileFacetsTouch.startY;
    this.mobileFacetsTouch.lastX = touch.clientX;
    this.mobileFacetsTouch.lastY = touch.clientY;

    if (
      !this.mobileFacetsTouch.mode &&
      this.shouldStartMobileFacetsDrag(dx, dy)
    ) {
      this.mobileFacetsTouch.mode = "drawer";
      this.classList.add("is-dragging");
    }

    if (this.mobileFacetsTouch.mode !== "drawer") return;

    event.preventDefault();
    if (this.mobileFacetsTouch.scroller)
      this.mobileFacetsTouch.scroller.scrollTop = 0;
    this.mobileFacetsInner.style.setProperty(
      "--mobile-facets-drag-y",
      `${Math.max(0, dy)}px`
    );
  }

  onMobileFacetsTouchEnd() {
    const touchState = this.mobileFacetsTouch;
    let dy;
    let velocity;

    if (!touchState || !this.mobileFacetsInner) return;

    dy = touchState.lastY - touchState.startY;
    velocity = dy / Math.max(Date.now() - touchState.startTime, 1);

    if (touchState.mode === "drawer") {
      this.classList.remove("is-dragging");
      this.mobileFacetsInner.style.setProperty(
        "--mobile-facets-drag-y",
        "0px"
      );

      if (dy > 96 || velocity > 0.55) {
        this.closeMenuDrawer(
          new Event("mobile-facets-swipe-close"),
          this.mainDetailsToggle.querySelector("summary")
        );
      }
    }

    this.mobileFacetsTouch = null;
  }

  shouldStartMobileFacetsDrag(dx, dy) {
    const touchState = this.mobileFacetsTouch;
    const dragThreshold =
      touchState && touchState.startedOnDragArea ? 3 : 10;
    const contentScrollTop =
      touchState && touchState.scroller ? touchState.scroller.scrollTop : 0;

    return (
      touchState &&
      !touchState.startedOnInteractive &&
      dy > dragThreshold &&
      Math.abs(dy) > Math.abs(dx) &&
      touchState.startScrollTop <= 1 &&
      contentScrollTop <= 1
    );
  }

  isMobileFacetsDrawerOpen() {
    return (
      this.classList.contains("mobile-facets__wrapper") &&
      this.mainDetailsToggle &&
      this.mainDetailsToggle.classList.contains("menu-opening") &&
      (!window.matchMedia || window.matchMedia("(max-width: 749px)").matches)
    );
  }

  resetMobileFacetsDrag() {
    if (!this.classList.contains("mobile-facets__wrapper")) return;

    this.classList.remove("is-dragging");
    this.mobileFacetsTouch = null;
    if (this.mobileFacetsInner) {
      this.mobileFacetsInner.style.setProperty(
        "--mobile-facets-drag-y",
        "0px"
      );
    }
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem =
      this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth
    );
    this.totalPages = this.isCenteredProductGallery()
      ? this.sliderItemsToShow.length
      : this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  isCenteredProductGallery() {
    return this.id.startsWith('GalleryViewer-') &&
      window.matchMedia('(max-width: 749px)').matches && Boolean(this.closest('.product-detail-section'));
  }

  update() {
    const previousPage = this.currentPage;
    if (this.isCenteredProductGallery()) {
      const viewport = this.slider.getBoundingClientRect();
      const center = viewport.left + viewport.width / 2;
      let nearest = Infinity;
      this.sliderItemsToShow.forEach((slide, index) => {
        const bounds = slide.getBoundingClientRect();
        const distance = Math.abs(bounds.left + bounds.width / 2 - center);
        if (distance < nearest) {
          nearest = distance;
          this.currentPage = index + 1;
        }
      });
    } else {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - step * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  connectedCallback() {
    this.sortQuantityOptions();
    this.updateOptions();
    this.updateAvailableOptions();
  }

  sortQuantityOptions() {
    const selectWrappers = Array.from(this.querySelectorAll(".product-form__input--dropdown"));
    
    selectWrappers.forEach((wrapper) => {
      const label = wrapper.querySelector("label");
      if (!label || !label.textContent.toLowerCase().includes("quantity")) return;

      const select = wrapper.querySelector("select");
      if (!select) return;

      const options = Array.from(select.querySelectorAll("option"));
      
      // Check if all values are numeric
      const allNumeric = options.every((opt) => !isNaN(parseFloat(opt.value)));
      if (!allNumeric) return;

      // Sort options by numeric value
      const sortedOptions = options.sort((a, b) => parseFloat(a.value) - parseFloat(b.value));

      // Clear and re-add sorted options
      select.innerHTML = "";
      sortedOptions.forEach((opt) => select.appendChild(opt));
    });
  }

  onVariantChange() {
    // Invalidate any response for the previous selection, including when the
    // next combination has no variant and does not start another request.
    this.productInfoRequest = null;
    this.updateOptions();
    this.updateAvailableOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateAvailableOptions() {
    const selects = Array.from(this.querySelectorAll("select"));
    let selectionChanged = false;

    selects.forEach((select, selectIndex) => {
      const options = Array.from(select.querySelectorAll("option"));

      options.forEach((option) => {
        const isSelectable = this.isOptionValueSelectable(selectIndex, option.value);
        const isAvailable = this.isOptionValueAvailable(selectIndex, option.value);

        option.disabled = !isSelectable;
        option.hidden = !isSelectable;
        if (!isSelectable) {
          option.textContent = option.value + " - Unavailable";
        } else if (!isAvailable) {
          option.textContent = option.value + " - Sold out";
        } else {
          option.textContent = option.value;
        }
      });

      // If currently selected option is disabled, select first available
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption && selectedOption.disabled) {
        const firstAvailable = options.find((opt) => !opt.disabled && this.isOptionValueAvailable(selectIndex, opt.value))
          || options.find((opt) => !opt.disabled);
        if (firstAvailable) {
          select.value = firstAvailable.value;
          this.options[selectIndex] = firstAvailable.value;
          selectionChanged = true;
        }
      }
    });

    // If we changed a selection, re-run to update downstream options
    if (selectionChanged) {
      this.updateOptions();
      this.updateMasterId();
      this.updateAvailableOptions();
    }
  }

  isOptionValueSelectable(optionIndex, value) {
    return this.getVariantData().some((variant) => {
      return this.variantMatchesOptionPath(variant, optionIndex, value);
    });
  }

  isOptionValueAvailable(optionIndex, value) {
    return this.getVariantData().some((variant) => {
      return variant.available && this.variantMatchesOptionPath(variant, optionIndex, value);
    });
  }

  variantMatchesOptionPath(variant, optionIndex, value) {
    if (!variant || !Array.isArray(variant.options)) return false;
    if (variant.options[optionIndex] !== value) return false;

    return this.options.slice(0, optionIndex).every((option, index) => {
      return !option || variant.options[index] === option;
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    if (!this.dataset.section) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );

    if (!mediaGallery || !mediaGallery.setActiveMedia) return;

    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );

    if (!modalContent || !modalContent.querySelector) return;

    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );

    if (modalContent.querySelector) return;

    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      // const input = productForm.querySelector('input[data-productid]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const variant = this.currentVariant;
    const request = this.productInfoRequest = {};
    return fetch(
      `${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.productInfoRequest !== request) return;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const priceIds = [
          `price-${this.dataset.section}`,
          `price-quantity-${this.dataset.section}`,
        ];

        priceIds.forEach((id) => {
          const destination = document.getElementById(id);
          const source = html.getElementById(id);

          if (source && destination) destination.innerHTML = source.innerHTML;
        });

        const promiseId = `ProductDetailPromise-${this.dataset.section}`;
        const promiseDestination = document.getElementById(promiseId);
        const promiseSource = html.getElementById(promiseId);

        if (promiseSource && promiseDestination) promiseDestination.innerHTML = promiseSource.innerHTML;

        const restockId = `ProductRestock-${this.dataset.section}`;
        const restockDestination = document.getElementById(restockId);
        const restockSource = html.getElementById(restockId);

        if (restockSource && restockDestination) {
          restockDestination.className = restockSource.className;
          restockDestination.innerHTML = restockSource.innerHTML;
          document.dispatchEvent(new CustomEvent("dubia:product-restock:update", {
            detail: {
              sectionId: this.dataset.section,
              variant
            }
          }));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        const quantityPrice = document.getElementById(
          `price-quantity-${this.dataset.section}`
        );

        if (price) price.classList.remove("visibility-hidden");
        if (quantityPrice) quantityPrice.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !variant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
      else updateProductAddButtonLabel(productForm, this.currentVariant);
    } else {
      addButton.removeAttribute("disabled");
      updateProductAddButtonLabel(productForm, this.currentVariant);
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const quantityPrice = document.getElementById(
      `price-quantity-${this.dataset.section}`
    );
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (quantityPrice) quantityPrice.classList.add("visibility-hidden");

    const promise = document.getElementById(`ProductDetailPromise-${this.dataset.section}`);
    const restock = document.getElementById(`ProductRestock-${this.dataset.section}`);

    if (promise) promise.innerHTML = "";
    if (restock) {
      restock.classList.remove("has-restock");
      restock.innerHTML = "";
    }

    document.dispatchEvent(new CustomEvent("dubia:product-restock:update", {
      detail: {
        sectionId: this.dataset.section,
        variant: null
      }
    }));
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateAvailableOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    let selectionChanged = false;

    fieldsets.forEach((fieldset, fieldsetIndex) => {
      const inputs = Array.from(fieldset.querySelectorAll("input"));

      inputs.forEach((input) => {
        const label = fieldset.querySelector(`label[for="${input.id}"]`);
        const isAvailable = this.isOptionValueAvailable(fieldsetIndex, input.value);
        const isSelectable = this.isOptionValueSelectable(fieldsetIndex, input.value);

        input.disabled = !isSelectable;
        const choice = input.closest('.product-option-choice');
        if (choice) choice.hidden = !isSelectable;
        if (label) {
          label.hidden = !isSelectable;
          label.classList.toggle("sold-out", isSelectable && !isAvailable);
        }
      });

      // If currently selected option is disabled, select first available
      const checkedInput = inputs.find((input) => input.checked);
      if (checkedInput && checkedInput.disabled) {
        const firstAvailable = inputs.find((input) => !input.disabled && this.isOptionValueAvailable(fieldsetIndex, input.value))
          || inputs.find((input) => !input.disabled);
        if (firstAvailable) {
          firstAvailable.checked = true;
          this.options[fieldsetIndex] = firstAvailable.value;
          selectionChanged = true;
        }
      }
    });

    // If we changed a selection, re-run to update downstream options
    if (selectionChanged) {
      this.updateOptions();
      this.updateMasterId();
      this.updateAvailableOptions();
    }
  }

  sortQuantityOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector("legend");
      if (!legend || !legend.textContent.toLowerCase().includes("quantity")) return;

      const inputs = Array.from(fieldset.querySelectorAll("input[type='radio']"));
      
      // Check if all values are numeric
      const allNumeric = inputs.every((input) => !isNaN(parseFloat(input.value)));
      if (!allNumeric) return;

      // Sort inputs by numeric value
      const sortedInputs = inputs.sort((a, b) => parseFloat(a.value) - parseFloat(b.value));

      // Reorder DOM elements
      sortedInputs.forEach((input) => {
        const choice = input.closest('.product-option-choice');
        if (choice) {
          choice.parentElement.appendChild(choice);
          return;
        }
        const label = fieldset.querySelector(`label[for="${input.id}"]`);
        fieldset.appendChild(input);
        if (label) fieldset.appendChild(label);
      });
    });
  }

  connectedCallback() {
    this.sortQuantityOptions();
    this.updateOptions();
    this.updateAvailableOptions();
  }
}

customElements.define("variant-radios", VariantRadios);

/* custom */

(function () {
  if (window.DubiaCartCounts) return;

  function normalizeCartCount(value) {
    if (value === null || typeof value === "undefined") return null;

    if (typeof value === "number") {
      return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : null;
    }

    var match = String(value).match(/\d+/);
    return match ? Math.max(0, parseInt(match[0], 10)) : null;
  }

  function extractCartCountFromRoot(root) {
    if (!root || !root.querySelector) return null;

    var bubble =
      root.matches && root.matches(".cart-count-bubble")
        ? root
        : root.querySelector(".cart-count-bubble");

    if (!bubble || bubble.hasAttribute("hidden")) return 0;

    var visibleValue = bubble.querySelector(
      "[data-cart-count-value], [aria-hidden='true']"
    );
    var visibleCount =
      visibleValue && visibleValue.textContent.trim()
        ? normalizeCartCount(visibleValue.textContent)
        : null;

    if (visibleCount !== null) return visibleCount;

    var hiddenText = bubble.querySelector(
      "[data-cart-count-text], .visually-hidden"
    );

    return hiddenText ? normalizeCartCount(hiddenText.textContent) : null;
  }

  function extractCartCountFromSectionHtml(html) {
    if (!html) return null;

    var doc = new DOMParser().parseFromString(html, "text/html");
    return extractCartCountFromRoot(doc);
  }

  function createFooterCartBubble() {
    var bubble = document.createElement("span");
    var visibleValue = document.createElement("span");
    var hiddenText = document.createElement("span");

    bubble.className = "cart-count-bubble";
    bubble.setAttribute("data-footer-cart-count-bubble", "");

    visibleValue.setAttribute("aria-hidden", "true");
    visibleValue.setAttribute("data-cart-count-value", "");

    hiddenText.className = "visually-hidden";
    hiddenText.setAttribute("data-cart-count-text", "");

    bubble.appendChild(visibleValue);
    bubble.appendChild(hiddenText);

    return bubble;
  }

  function getAccessibleCartCountText(count) {
    return count === 1 ? "1 item in cart" : count + " items in cart";
  }

  function updateFooterCartCount(count) {
    document
      .querySelectorAll("[data-footer-mobile-nav] .dr-footer-mobile-nav__item--cart")
      .forEach(function (cartItem) {
        var inner = cartItem.querySelector(".dr-footer-mobile-nav__inner");
        if (!inner) return;

        var bubble =
          cartItem.querySelector("[data-footer-cart-count-bubble]") ||
          cartItem.querySelector(".cart-count-bubble");

        if (!bubble) {
          bubble = createFooterCartBubble();
          inner.appendChild(bubble);
        }

        var visibleValue =
          bubble.querySelector("[data-cart-count-value]") ||
          bubble.querySelector("[aria-hidden='true']");
        var hiddenText =
          bubble.querySelector("[data-cart-count-text]") ||
          bubble.querySelector(".visually-hidden");

        if (count <= 0) {
          bubble.setAttribute("hidden", "");
          if (visibleValue) visibleValue.textContent = "";
          if (hiddenText) hiddenText.textContent = getAccessibleCartCountText(0);
          return;
        }

        bubble.removeAttribute("hidden");

        if (visibleValue) {
          visibleValue.textContent = count < 100 ? String(count) : "";
        }

        if (hiddenText) {
          hiddenText.textContent = getAccessibleCartCountText(count);
        }
      });
  }

  function updateHeaderCartState(count) {
    var header = document.querySelector(".header[data-cart-item-count]");
    if (!header) return;

    header.dataset.cartItemCount = String(count);
    header.classList.toggle("header--has-cart-items", count > 0);
  }

  function updateCartCount(value, options) {
    var count = normalizeCartCount(value);
    if (count === null) return;

    updateFooterCartCount(count);
    updateHeaderCartState(count);

    if (!options || options.dispatch !== false) {
      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: {
            item_count: count,
          },
        })
      );
    }
  }

  window.DubiaCartCounts = {
    update: updateCartCount,
    extractFromRoot: extractCartCountFromRoot,
    extractFromSectionHtml: extractCartCountFromSectionHtml,
  };

  document.addEventListener("cart:updated", function (event) {
    if (!event.detail || typeof event.detail.item_count === "undefined") return;
    updateCartCount(event.detail.item_count, { dispatch: false });
  });
})();

function setFooterMobileActiveItem(nav, item) {
  if (!nav || !item) return;

  const index = item.getAttribute("data-footer-nav-index");
  if (index === null) return;

  nav.classList.add("is-animated");
  updateFooterMobileIndicator(nav, item);
  Array.from(nav.querySelectorAll("[data-footer-nav-index]")).forEach(
    (navItem) => {
      const isActive = navItem === item;
      navItem.classList.toggle("is-active", isActive);

      if (isActive && navItem.tagName === "A") {
        navItem.setAttribute("aria-current", "page");
      } else {
        navItem.removeAttribute("aria-current");
      }
    }
  );
}

function updateFooterMobileIndicator(nav, item) {
  if (!nav || !item) return;

  const navRect = nav.getBoundingClientRect();
  const itemRect = item.getBoundingClientRect();
  if (!navRect.width || !itemRect.width) return;

  const inset = Math.min(14, Math.max(8, itemRect.width * 0.18));
  const left = itemRect.left - navRect.left + inset;
  const width = Math.max(18, itemRect.width - inset * 2);

  nav.style.setProperty("--dr-footer-active-left", `${Math.round(left)}px`);
  nav.style.setProperty("--dr-footer-active-width", `${Math.round(width)}px`);
}

function shouldDelayFooterMobileNavigation(event, item) {
  if (!item || item.tagName !== "A") return false;
  if (
    event.defaultPrevented ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return false;
  }

  const href = item.getAttribute("href");
  if (!href || href.charAt(0) === "#") return false;

  const target = item.getAttribute("target");
  if (target && target !== "_self") return false;

  try {
    const nextUrl = new URL(item.href, window.location.href);
    if (nextUrl.origin !== window.location.origin) return false;
    if (nextUrl.href === window.location.href) return false;
  } catch (error) {
    return false;
  }

  return true;
}

function initFooterMobileNav(root) {
  const navRoot = root && root.querySelector ? root : document;
  const footerMobileNav =
    navRoot.matches && navRoot.matches("[data-footer-mobile-nav]")
      ? navRoot
      : navRoot.querySelector("[data-footer-mobile-nav]");

  if (!footerMobileNav || footerMobileNav.dataset.footerMobileNavBound === "true") {
    return;
  }

  footerMobileNav.dataset.footerMobileNavBound = "true";
  footerMobileNav.classList.remove("is-scroll-hidden", "is-scroll-settling");
  footerMobileNav.style.removeProperty("--dr-footer-scroll-offset");

  let footerMobileNavWidth = 0;
  let footerMobileNavResizeFrame = null;

  const updateCurrentIndicator = function (force = false) {
    const measuredWidth = Math.round(
      footerMobileNav.getBoundingClientRect().width
    );
    if (!force && measuredWidth === footerMobileNavWidth) return;
    footerMobileNavWidth = measuredWidth;

    const activeItem =
      footerMobileNav.querySelector("[data-footer-nav-index].is-active") ||
      footerMobileNav.querySelector("[data-footer-nav-index]");
    updateFooterMobileIndicator(footerMobileNav, activeItem);
    footerMobileNav.classList.add("is-ready");
  };

  window.requestAnimationFrame(function () {
    updateCurrentIndicator(true);
  });
  window.addEventListener(
    "resize",
    function () {
      if (footerMobileNavResizeFrame) return;
      footerMobileNavResizeFrame = window.requestAnimationFrame(function () {
        footerMobileNavResizeFrame = null;
        updateCurrentIndicator();
      });
    },
    { passive: true }
  );

  footerMobileNav.addEventListener("pointerdown", function (event) {
    const item = event.target.closest("[data-footer-nav-index]");
    if (!item || !footerMobileNav.contains(item)) return;
    setFooterMobileActiveItem(footerMobileNav, item);
  });

  footerMobileNav.addEventListener("click", function (event) {
    const item = event.target.closest("[data-footer-nav-index]");
    if (!item || !footerMobileNav.contains(item)) return;

    setFooterMobileActiveItem(footerMobileNav, item);

    if (item.classList.contains("dr-footer-mobile-nav__item--menu")) {
      const mainMenuToggle = document.querySelector(".dr-main-menu-toggle");
      if (mainMenuToggle) {
        const mainDetails = document.querySelector(
          "#Details-menu-drawer-container"
        );
        const wasOpen = mainDetails && mainDetails.hasAttribute("open");
        if (mainDetails) {
          mainDetails.classList.add("menu-drawer-container--footer-triggered");
        }

        mainMenuToggle.click();

        window.setTimeout(function () {
          item.setAttribute(
            "aria-expanded",
            wasOpen ? "false" : "true"
          );
          if (wasOpen) {
            mainMenuToggle.classList.remove("focused");
            mainMenuToggle.blur();
            item.focus({ preventScroll: true });
          }
        }, 0);
      }
      return;
    }

    if (item.classList.contains("dr-footer-mobile-nav__item--message")) {
      if (window.Reamaze && typeof window.Reamaze.popup === "function") {
        window.Reamaze.popup();
      }
      return;
    }

    if (shouldDelayFooterMobileNavigation(event, item)) {
      event.preventDefault();
      const href = item.href;
      window.setTimeout(function () {
        window.location.href = href;
      }, 170);
    }
  });
}

initFooterMobileNav(document);
document.addEventListener("DOMContentLoaded", function () {
  initFooterMobileNav(document);
});
document.addEventListener("shopify:section:load", function (event) {
  initFooterMobileNav(event.target);
});

waitForjQuery(function () {
  var $ = window.jQuery;

  $(".dr-open-dubia-search").on("click", function (e) {
    if (!this.matches("[data-dubia-search-input]")) {
      e.preventDefault();
    }

    var dubiaSearch = document.querySelector("dubia-search");

    if (dubiaSearch) {
      dubiaSearch.setAttribute("show", "true");
    }
  });

  // var $bars = $('.announcement-bar--closable');

  // function getBarsFromStorage() {
  //   var closedBars = JSON.parse(getCookie('dubia-announcement-bars') || JSON.stringify([]));

  //   return closedBars;
  // }

  // $bars.each(function () {
  //   var id = $(this).data('id');

  //   if (!getBarsFromStorage().includes(id)) {
  //     $(this).removeClass('hidden');
  //   }
  // });

  // $bars.find('.announcement-bar__close').on('click', function (e) {
  //   e.preventDefault();

  //   var storageKey = 'dubia-announcement-bars';
  //   var currentClosedBars = getBarsFromStorage();

  //   currentClosedBars.push($(this).data('id'));

  //   setCookie(storageKey, JSON.stringify(currentClosedBars), 14);

  //   $(this).closest('.announcement-bar--closable').addClass('hidden');
  // });

  $("body").on("click", function (e) {
    setTimeout(function () {
      var $mainDetails = document.querySelector(
        "#Details-menu-drawer-container"
      );
      var $menuItem = document.querySelector(
        ".dr-footer-mobile-nav__item--menu"
      );

      if (!$menuItem || !$mainDetails) return;

      var isOpen = $mainDetails.hasAttribute("open");

      $menuItem.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }, 200);
  });

  /** Sliding Announcement Bar */

  var sliderContainer = $(".announcement-bars");
  var slides = $(".announcement-bars .announcement-bar").not("[hidden]");
  var slideItems = $(".announcement-bars__items");
  var slidesLength = slides.length;

  sliderContainer.addClass("dr-slider-initiated");

  var activeSlideIndex = 0;

  var changeSlide = (direction) => {
    const sliderHeight = sliderContainer.height();
    if (direction === "up") {
      activeSlideIndex++;
      if (activeSlideIndex > slidesLength - 1) {
        activeSlideIndex = 0;
      }
    } else if (direction === "down") {
      activeSlideIndex--;
      if (activeSlideIndex < 0) {
        activeSlideIndex = slidesLength - 1;
      }
    }

    var translateY = activeSlideIndex * sliderHeight;

    slideItems.css("transform", `translateY(-${translateY}px) translateZ(0)`);
  };

  setInterval(function () {
    changeSlide("up");
  }, 5000);
});

function waitForjQuery(runMethod) {
  if (!window.jQuery) {
    setTimeout(function () {
      waitForjQuery(runMethod);
    }, 200);
  } else {
    runMethod();
  }
}

function getCookie(name) {
  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

// function waitForElement (el, runMethod) {
//   if (!el) {
//     setTimeout(function () {
//       waitForElement(el);
//     }, 100);
//   } else {
//     runMethod()
//   }
// }

// function rewardsNavClick () {
//   const $ = window.jQuery;

//   waitForElement($('.smile-launcher-frame'), function () {
//     var icon = $('.smile-launcher-frame').contents().find('.launcher-icon');

//     waitForElement(icon, function () {
//       icon.css('visibility', 'hidden');
//     });
//   });
// }

// waitForjQuery(function () {
//   rewardsNavClick();
// })
